/**
 * @section 4.1.9.3
 */
/* eslint-disable no-template-curly-in-string, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
import IconButton from "@material-ui/core/IconButton";
import ProjectsIcon from "@material-ui/icons/AssignmentOutlined";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import SearchIcon from "@material-ui/icons/Search";
import * as registry from "@qpr/client-api-registry";
import { t } from "i18next";
import { sortBy } from "lodash";
import React from "react";
import { Column } from "react-table";
import useMyWorkflowQuery from "./../../apihooks/useMyWorkflows";
import { useAppContext } from "./../../context/AppCtxProvider";
import { mea_t, stringTemplate } from "./../../tplutils/utils";
import SelectorMenu from "./../../ui/components/Selector";
import ShowRejectMessage from "./../../ui/components/ShowRejectMessage";
import WorkflowTable from "./../../ui/components/WorkflowTable";
import { makeThemedStyles } from "./../../viewcomponents/utils";
import { IProjectState, IProjectValues } from "./workflowTypes";
type IWorkflowProjectList = {
  query: string;
  attributes?: string;
  criteria: string;
  isAcceptComponent?: boolean;
  cssPrefix?: string;
  url?: string;
  workflowPeriod?: string;
  workflowSeries?: string;
  workflowType?: string;
  cssVariables?: Array<{
    name: string;
    value: string;
  }>;
  values?: any[];
  projectVal?: IProjectValues;
  enabled?: boolean;
};
const useStyles = makeThemedStyles("MilestoneInput.Heading", (theme) => ({
  "@global": {
    ".WorkflowProjectList": {
      "& .statusInfo": {
        color: "rgba(227, 181, 7, 1)",
        padding: "2px 14px",
        lineHeight: "20px",
        background: "rgba(227, 181, 7, 0.1)",
        borderRadius: "26px",
      },
      "& .data_entry": {
        color: "rgba(115, 120, 124, 1)",
        background: "rgba(159, 175, 178, 0.1)",
      },
    },
  },
  projectsIcon: {
    width: "40px",
    height: "40px",
    color: "rgb(0, 169, 163)",
    verticalAlign: "middle",
    margin: "0.3em",
  },
  backButton: {
    width: "37px",
    height: "36px",
    backgroundColor: "#fff",
    padding: "4px",
    margin: "4px",
    marginRight: "16px",
  },
  pageTitle: {
    margin: "1em",
    fontSize: "2.6em",
    color: "rgb(76,81,87)",
    fontWeight: 500,
    width: "100%",
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
  },
  pageTitleContainer: {
    alignItems: "center",
    paddingRight: "0em",
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "-2.9em",
  },
  helperContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginRight: "3.1em",
  },
  searchOptions: {
    width: "21.73em",
    height: "5.58em",
    borderRadius: "2.85em",
    backgroundColor: "#fff",
    alignItems: "center",
    display: "flex",
    justifyContent: "space-between",
    marginRight: "0.62em",
    marginLeft: "0.62em",
  },
  inputSearch: {
    display: "block",
    margin: "auto",
    height: "3.14em",
    width: "100%",
    borderRadius: "2.10em",
    border: "none",
    outline: "none",
    fontFamily: "Dubai, Ample",
  },
  tobarIcon: {
    color: "rgba(17, 94, 103, 1)",
    marginLeft: `0.36em`,
    marginRight: "0.33em",
    borderRadius: "50%",
  },
  iconContainer: {
    display: "flex",
  },
}));
const T = (str: string) => `${t(str)}`;
export const wfStatesMap = [
  {
    statename: "dataentry",
    uiname: "Created",
    stepnumber: 1,
  },
  {
    statename: "approval",
    uiname: "Submitted",
    stepnumber: 2,
  },
  {
    statename: "approvalrejected",
    uiname: "Rejected",
    stepnumber: 1,
  },
  {
    statename: "finalapproval",
    uiname: "Approved",
    stepnumber: 3,
  },
  {
    statename: "finalapprovalrejected",
    uiname: "Final rejected",
    stepnumber: 2,
  },
  {
    statename: "approved",
    uiname: "Closed",
    stepnumber: 4,
  },
];
const WorkflowProjectList = (props: {
  componentData: IWorkflowProjectList;
  options?: any;
  setSelectedRowIs?: (data: any) => void;
}) => {
  const classes = useStyles();
  const ctx = useAppContext();
  const [filteredData, setFilteredData] = React.useState<
    IProjectState[] | undefined
  >([]);
  const [status, setStatus] = React.useState<undefined | string>("");
  const [reload, setReload] = React.useState(false);
  const [isModalOpen, setModalOpen] = React.useState(false);
  const [rejectmsgm, setRejectmsg] = React.useState("");
  const { setSelectedRowIs } = props;
  const { data, isError } = useMyWorkflowQuery<IProjectState[]>(
    props.componentData.query,
    {
      attributes: stringTemplate(props.componentData.attributes || "", { ctx }),
      type: "value",
      values: props.componentData.values,
      criteria: props.componentData.criteria,
      enabled: props.componentData.enabled,
    }
  );
  React.useEffect(() => {
    setFilteredData(data?.data);
  }, [data]);
  React.useEffect(() => {
    const getSelctedData = data?.data.filter((val) => val.id === ctx.elementId);
    if (setSelectedRowIs) setSelectedRowIs(getSelctedData);
  }, [ctx, data]);
  const handleShowMsg = (dataRow: any) => {
    setModalOpen(!isModalOpen);
    setRejectmsg(dataRow.workflow?.latestLog?.message);
  };
  const onUpdateValues = () => {
    setFilteredData((val) => {
      const updatedValue = props.componentData.projectVal;
      const subdata = updatedValue?.wf?.nextTransitions;
      if (updatedValue && !subdata?.length) {
        const totalData = data?.data.filter(
          (tdata) => tdata.id !== updatedValue?.elementId
        );
        if (!totalData) return;
        return totalData;
      }
      if (updatedValue && data?.data) {
        return data.data.map((item) => {
          if (item.id === updatedValue.elementId) {
            const actual = updatedValue.actualProgress;
            const workflow = updatedValue.wf;
            return { ...item, actual, workflow };
          }
          return item;
        });
      }
      return val;
    });
    setReload(() => {
      if (
        props.componentData.projectVal?.wf?.nextTransitions &&
        !props.componentData.projectVal?.wf?.nextTransitions?.length
      )
        return true;
      return false;
    });
  };
  React.useEffect(() => {
    onUpdateValues();
  }, [props.componentData]);
  const findSearchData = (
    list: IProjectState[] | undefined,
    searchdata?: string
  ) => {
    let res: any[] = [];
    if (list && searchdata) {
      list.forEach((elem) => {
        let dataname = elem.name.toLowerCase();
        if (dataname.includes(searchdata.toLowerCase())) {
          res.push(elem);
        }
      });
    } else {
      res = list || [];
    }
    return res;
  };
  const findMatchingData = (
    list: IProjectState[] | undefined,
    match?: string
  ) => {
    let res: IProjectState[] = [];
    if (list && match) {
      list.forEach((elem) => {
        if (elem.workflow?.message === match) {
          res.push(elem);
        }
      });
    } else {
      res = list || [];
    }
    res = sortBy(res, ["name"]).map((e) => {
      if (e.workflow && e.workflow.currentState)
        e.workflow.currentState =
          wfStatesMap.find(
            (el) => el.statename === e.workflow?.currentState.toLowerCase()
          )?.uiname || e.workflow.currentState;
      return e;
    });
    return res;
  };
  const handleSearch = (value: any) => {
    const searchedData = findSearchData(data?.data, value);
    setFilteredData(searchedData);
  };
  const Message = registry.getSvg("Message");
  const columns: Column<IProjectState>[] = React.useMemo(() => {
    let cols: Column<IProjectState>[] = [
      {
        Header: T("Project Name"),
        accessor: "name",
        Cell: (row: any) => {
          const dataRow = row.row.original as IProjectState;
          return (
            <div>
              <p>{mea_t("Name", dataRow.JS_ATTR, ctx.language) || ""}</p>
            </div>
          );
        },
      },
    ];
    if (props.componentData.isAcceptComponent) {
      cols.push({
        Header: T("Status"),
        accessor: "status",
        Cell: (row: any) => {
          const dataRow = row.row.original as IProjectState;
          return (
            <>
              <div
                className={`statusInfo ${(
                  dataRow.workflow?.currentState || "nostate"
                )
                  .toLowerCase()
                  .replace(/\s/g, "_")}`}
              >
                {dataRow.workflow?.message ? t(dataRow.workflow?.message) : ""}
              </div>
              {dataRow.workflow?.latestLog?.message &&
                dataRow.workflow?.latestLog?.message.length > 0 && (
                  <div className="msgIcon">
                    <Message onClick={() => handleShowMsg(dataRow)} />
                  </div>
                )}
            </>
          );
        },
      });
      cols.push({
        Header: T("Period"),
        accessor: "period",
        Cell: (row: any) => {
          if (!row?.row?.original?.workflow?.period) {
            return <div className="novalue" />;
          }
          return (
            <div className="periodValue">
              <div>
                <p>{row?.row?.original?.workflow?.period}</p>
              </div>
            </div>
          );
        },
      });
    }
    cols = [
      ...cols,
      {
        Header: T("Actual Progress"),
        accessor: "actual",
        Cell: (row: any) => {
          if (!row.row.original.actual) {
            return <div className="novalue" />;
          }
          const unitName =
            row.row.original.unitname === "Percentage" ? "%" : t("M");
          return (
            <div className="value">
              <div className="number">{row.row.original.actual}</div>
              <div className="pros">{unitName}</div>
            </div>
          );
        },
      },
      {
        Header: T("Planned Progress"),
        accessor: "target",
        Cell: (row: any) => {
          if (!row.row.original.target) {
            return <div className="novalue" />;
          }
          const unitName =
            row.row.original.unitname === "Percentage" ? "%" : t("M");
          return (
            <div className="value">
              <div className="number">{row.row.original.target}</div>
              <div className="pros">{unitName}</div>
            </div>
          );
        },
      },
    ];
    if (props.componentData.isAcceptComponent) {
      cols.unshift({
        accessor: "id",
        Header: "",
        Cell: (row: any) => {
          const dataRow = row.row.original as IProjectState;
          const isOn = row?.row?.original?.workflow?.done;
          return (
            <div className={classes.iconContainer}>
              {isOn ? <CheckCircleIcon /> : ""}
            </div>
          );
        },
      });
    }
    return cols;
  }, [props.componentData.isAcceptComponent, ctx.language]);
  if (isError) {
    return <div>Error loading data</div>;
  }
  if (!data) {
    return null;
  }
  return (
    <div>
      <div className={classes.pageTitleContainer}>
        <div className={classes.pageTitle}>
          <IconButton className={classes.backButton}>
            {ctx.rtl ? (
              <ChevronRight fontSize="large" />
            ) : (
              <ChevronLeft fontSize="large" />
            )}
          </IconButton>
          <ProjectsIcon className={classes.projectsIcon} />
          {t("Projects")}
        </div>
        <div className={classes.helperContainer}>
          <div className={classes.searchOptions}>
            <SearchIcon
              fontSize="large"
              className={classes.tobarIcon}
              aria-hidden="true"
            />
            <input
              type="text"
              className={classes.inputSearch}
              placeholder={t("Search for")}
              id="search"
              onChange={(e) => handleSearch(e.target.value)}
              name="search"
            />
          </div>
          <SelectorMenu
            data={[t("Waiting for input"), t("Waiting For Approval")]}
            handleOnClick={(selectedStatus: any) => {
              setStatus(selectedStatus);
            }}
            label={t(status || "Filter by status")}
            selectedValue=""
          />
        </div>
      </div>
      <WorkflowTable
        data={findMatchingData(filteredData, status)}
        columns={columns}
        reloadData={reload}
        url={props.componentData.url}
        classPrefix="WorkflowProject"
      />
      <ShowRejectMessage
        show={isModalOpen}
        message={rejectmsgm}
        handleModel={setModalOpen}
      />
    </div>
  );
};
export default WorkflowProjectList;
